import { createSelector } from '@reduxjs/toolkit'
import { addDays, isAfter, parseISO } from 'date-fns'
import { RootState } from '../../../store/slices/reducers'

import { DEFAULT_PROFILE_IMG } from '../../../config'

const authSelector = (state: RootState) => state.auth

const authIsLoggedInSelector = (state: RootState) => state.auth.isLoggedIn

const authIsLoadingSelector = (state: RootState) => state.auth.isLoading

const authUserSelector = (state: RootState) => state.auth.user

const tempAuthUserSelector = (state: RootState) => state.auth.temUser

const supportsSelector = (state: RootState) => state.auth.supports

// const supportDataSelector = (state: RootState) => state.auth.supports?.support

// const accountManagerDataSelector = (state: RootState) =>
//   state.auth.supports?.accountManager

const userSelector = createSelector(authUserSelector, (user) => {
  if (!user?.id) return null

  const COMPARE_DAY = 90
  const timeCompare = user?.create_timestamp
    ? addDays(parseISO(user?.create_timestamp), COMPARE_DAY)
    : new Date()

  const isCreateTimeThanThreeMonthAgo = isAfter(timeCompare, new Date())

  return {
    ...user,
    name: `${user.first_name} ${user.last_name}`,
    companyLogo: user.company_logo || DEFAULT_PROFILE_IMG,
    isCreateTimeThanThreeMonthAgo,
  }
})

const loggedSelector = (state: RootState) => state.auth.logged

const appSelector = createSelector(userSelector, (user) => {
  try {
    if (!user) return 'brokerinfo'

    if (user.app) return user.app

    let app = 'brokerinfo'
    const userLandDev = user?.roles?.includes('User_landdev')

    if (userLandDev) {
      app = userLandDev ? 'landdev' : 'brokerinfo'
    }

    return app
  } catch (error) {
    console.error(error)

    return 'brokerinfo'
  }
})

const authRolesSelector = createSelector(authUserSelector, (user) => {
  return user?.roles?.map((role: { name: string }) => role.name) || []
})

const isCompanyAdminSelector = createSelector(authRolesSelector, (roles) => {
  return roles.includes('Admin_company')
})

const landdevSelector = createSelector(appSelector, (app) => app === 'landdev')

const sharedSelector = createSelector(authUserSelector, (user) => {
  return user?.share_policy || {}
})

const isPopetyCompanySelector = createSelector(userSelector, (user) => {
  return !!user && user?.company_id === '1' /* POPETY company id */
})

const needVerifySelector = (state: RootState) => state.auth?.needVerify

const closedConfirmPhoneSelector = (state: RootState) =>
  state.auth?.closedConfirmPhone

const userIdSelector = (state: RootState) => state.auth.user?.id

const companyIdSelector = (state: RootState) => state.auth.user?.company_id

export {
  authSelector,
  authRolesSelector,
  userSelector,
  loggedSelector,
  appSelector,
  isCompanyAdminSelector,
  supportsSelector,
  landdevSelector,
  sharedSelector,
  isPopetyCompanySelector,
  authIsLoadingSelector,
  // accountManagerDataSelector,
  // supportDataSelector,
  needVerifySelector,
  closedConfirmPhoneSelector,
  authIsLoggedInSelector,
  tempAuthUserSelector,
  userIdSelector,
  companyIdSelector,
}
